import Sidebar from "./Sidebar";

const PageContainer = ({ children }) => {
  return (
    <div className="grid grid-cols-[12rem_1fr] h-content">
      <Sidebar />
      <div className="grid grid-rows-[min-content_1fr] overflow-auto">
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
